export default __webpack_public_path__ + "static/media/ecologi.f6873b63.svg";